export default "__VITE_ASSET__rTLVuK7d__"